import { useState } from 'react';
import { Modal } from '../components/Modal';
import { PROFILE_EMOJIS } from '../state';

type Props = {
    current: string;
    onClose: () => void;
    onPick: (e: string) => void;
};

/**
 * Profile-avatar picker.
 *
 * Per ТЗ (Разделы бота.md): "встроить пул эмодзи и сделать 2 стрелочки чтобы
 * можно было удобно листать и менять". Primary control is a large preview
 * with ◀ / ▶ arrows that step through PROFILE_EMOJIS one at a time; the grid
 * stays as a fast-jump alternative for users who want to scan all options.
 *
 * The chosen emoji is committed when the user presses "Сохранить" so
 * scrolling past several options doesn't fire a write for each step.
 */
export function EmojiPickerModal({ current, onClose, onPick }: Props) {
    const startIdx = Math.max(0, PROFILE_EMOJIS.indexOf(current));
    const [idx, setIdx] = useState(startIdx);
    const step = (delta: number) => {
        const n = PROFILE_EMOJIS.length;
        setIdx((i) => (i + delta + n) % n);
    };
    const selected = PROFILE_EMOJIS[idx] ?? current;

    const commit = () => {
        onPick(selected);
        onClose();
    };

    return (
        <Modal title="Выбор аватара" onClose={onClose}>
            <p className="popup-text text-center text-muted">
                Листайте стрелками или тапните по эмодзи.
            </p>

            <div className="emoji-scroller">
                <button
                    type="button"
                    className="emoji-arrow"
                    onClick={() => step(-1)}
                    aria-label="Предыдущий аватар"
                >
                    ◀
                </button>
                <div className="emoji-current" aria-live="polite" aria-label={`Выбран ${selected}`}>
                    {selected}
                </div>
                <button
                    type="button"
                    className="emoji-arrow"
                    onClick={() => step(1)}
                    aria-label="Следующий аватар"
                >
                    ▶
                </button>
            </div>

            <div className="emoji-grid">
                {PROFILE_EMOJIS.map((e, i) => (
                    <button
                        type="button"
                        key={e}
                        className={`emoji-pick ${e === selected ? 'selected' : ''}`}
                        onClick={() => setIdx(i)}
                        aria-label={`Аватар ${e}`}
                    >
                        {e}
                    </button>
                ))}
            </div>

            <button
                type="button"
                className="action-btn btn-red"
                onClick={commit}
                style={{ marginTop: 8 }}
            >
                Сохранить
            </button>
        </Modal>
    );
}
